import React, { useState } from 'react'
import Drawer from 'component/drawer'
import Icon from 'meinian-package/src/component/icon'
import ChooseTask from './chooseTask'
import TaskInspiration from './taskInspiration'
import styles from './index.module.less'

const TYPE = {
  chooseTask: 0,
  taskInspiration: 1
}

export default ({ visible, auth, onClose, info }) => {
  const [type, setType] = useState(TYPE.chooseTask)
  const [currentTask, setCurrentTask] = useState()

  const onCheckStyle = (val) => {
    setCurrentTask(val)
    setType(TYPE.taskInspiration)
  }

  return <Drawer
    placement="bottom"
    height="calc(100vh - 64px)"
    visible={visible}
  >
    <div className={styles['mn-choose-drawer-task']}>
      <div className="mn-drawer-close" onClick={onClose}>
        <Icon type="m-guanbi" className="mn-drawer-close-icon" />
      </div>
      {type === 0 ? <ChooseTask
        info={info}
        auth={auth}
        onCheckStyle={onCheckStyle}
      /> : <TaskInspiration
        currentTask={currentTask}
        onBack={() => setType(TYPE.chooseTask)}
      />}
    </div>
  </Drawer>
}
